import { useEffect, useState } from 'react';

// For components that need to be (at least for now) only client-side, so we hide til after rehydration.
const useIsAfterHydration = () => {
  const [isAfterHydration, setIsAfterRehydration] = useState(false);
  useEffect(() => setIsAfterRehydration(true), []);

  return isAfterHydration;
};

export default useIsAfterHydration;
